{
	"orderTerms": {
		"label": "Order Duration",
		"day": "DAY",
		"gtc": "GTC",
		"opg": "OPG",
		"cls": "CLS",
		"ioc": "IOC",
		"dayPlus": "DAY+"
	}
}
